package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.browser.uri.encodeURIComponent
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.api.ubl.UBLPostalAddress
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun UBLPostalAddressView(
    address: UBLPostalAddress,
    vertical: Boolean = false,
    showCountry: Boolean = false,
    showViewOnMapsLink: Boolean = false,
) {
    Span {
        Text(address.streetName)
        if (vertical) Br() else Text(", ")
        Text("${address.postalCode} ${address.cityName}")
        if (showCountry) {
            if (vertical) Br() else Text(", ")
            Text(address.countryCode)
        }
        if (showViewOnMapsLink) {
            val text = "${address.streetName}, ${address.postalCode} ${address.cityName}"
            val link = "https://www.google.com/maps/place/${encodeURIComponent(text)}"
            if (vertical) Br() else Text(" ")
            Anchor(link, {
            }) {
                Text("(auf Karte anzeigen)")
            }
        }
    }
}
